/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ImageVersionTypeName = "large" | "master" | "medium" | "original" | "placeholder" | "small" | "thumb" | "zoom" | "%future added value";
export type PdpSharedLayout_viewer = {
    readonly isPdpUrlTranslationEnabled?: boolean | null;
    readonly itemRead: ReadonlyArray<{
        readonly isMultiSku?: boolean;
        readonly defaultSkuId?: string | null;
        readonly pdpTrackingVpvParams?: unknown | null;
        readonly saveSearchData?: {
            readonly page: string | null;
        } | null;
        readonly microdata?: string | null;
        readonly pdpURL?: string | null;
        readonly localizedPdpUrl?: string | null;
        readonly pdpMeta?: {
            readonly title: string | null;
            readonly description: string | null;
            readonly ogTitle: string | null;
            readonly productPriceAmount: string | null;
            readonly productPriceCurrency: string | null;
        } | null;
        readonly photos?: ReadonlyArray<{
            readonly versions: ReadonlyArray<{
                readonly webPath: string | null;
                readonly type: {
                    readonly name: ImageVersionTypeName | null;
                } | null;
            } | null> | null;
        } | null> | null;
        readonly isListingNotListed?: boolean | null;
        readonly isMissingTranslatedItemTitle?: boolean | null;
        readonly isPriceUponRequest?: boolean | null;
        readonly seller?: {
            readonly isInternal: boolean | null;
            readonly serviceId: string | null;
        } | null;
        readonly isSold?: boolean | null;
        readonly metrics?: ReadonlyArray<{
            readonly value: string | null;
        } | null> | null;
        readonly attributes?: {
            readonly period: ReadonlyArray<{
                readonly option: {
                    readonly name: string | null;
                } | null;
            } | null> | null;
        } | null;
        readonly browseUrl?: string | null;
        readonly categoryCode?: string | null;
        readonly viewInRoomPhotos?: ReadonlyArray<{
            readonly src: string | null;
        } | null> | null;
        readonly contemporaryTrackingString?: string;
        readonly skus?: ReadonlyArray<{
            readonly skuId: string | null;
            readonly images: ReadonlyArray<{
                readonly id: string;
            } | null> | null;
        } | null> | null;
    } | null> | null;
    readonly transactions?: {
        readonly edges?: ReadonlyArray<{
            readonly node: {
                readonly skuId: string | null;
                readonly isPrivateOffer: boolean | null;
                readonly isCanceled: boolean | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "PdpSharedLayout_viewer";
};
export type PdpSharedLayout_viewer$data = PdpSharedLayout_viewer;
export type PdpSharedLayout_viewer$key = {
    readonly " $data"?: PdpSharedLayout_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedLayout_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "skuId",
  "args": null,
  "storageKey": null
},
v1 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "PdpSharedLayout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "itemIds",
      "type": "[String]!"
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "isClient",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "fetchPdp",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "userIds",
      "type": "[String]"
    },
    {
      "kind": "RootArgument",
      "name": "isMultiSku",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "forcedCurrency",
      "type": "Currency"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "itemRead",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemIds",
          "variableName": "itemIds"
        }
      ],
      "concreteType": null,
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "Item",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isMultiSku",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "defaultSkuId",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "saveSearchData",
              "storageKey": null,
              "args": null,
              "concreteType": "SaveSearchDataType",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "page",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "skus",
              "storageKey": null,
              "args": null,
              "concreteType": "ItemSkuType",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "images",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ItemPhoto",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "id",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            },
            {
              "kind": "Condition",
              "passingValue": true,
              "condition": "isClient",
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "pdpTrackingVpvParams",
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "userId",
                      "variableName": "userId"
                    }
                  ],
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "Condition",
              "passingValue": true,
              "condition": "fetchPdp",
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "microdata",
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "currency",
                      "variableName": "forcedCurrency"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "pdpURL",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "localizedPdpUrl",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "pdpMeta",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "pdpMetaItems",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "title",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "description",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "ogTitle",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "productPriceAmount",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "productPriceCurrency",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "photos",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ItemPhoto",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "versions",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "ItemPhotoVersion",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "webPath",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "type",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ImageVersionType",
                          "plural": false,
                          "selections": (v1/*: any*/)
                        }
                      ]
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "isListingNotListed",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "isMissingTranslatedItemTitle",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "isPriceUponRequest",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "seller",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Seller",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "isInternal",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "serviceId",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "isSold",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "metrics",
                  "storageKey": "metrics(metricTypes:[\"LISTING_VIEWS\"],timeRange:\"LAST_6_MONTHS\")",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "metricTypes",
                      "value": [
                        "LISTING_VIEWS"
                      ]
                    },
                    {
                      "kind": "Literal",
                      "name": "timeRange",
                      "value": "LAST_6_MONTHS"
                    }
                  ],
                  "concreteType": "MetricDetailType",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "value",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "attributes",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ItemAttributes",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "period",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "AttributeValue",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "option",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "AttributeOption",
                          "plural": false,
                          "selections": (v1/*: any*/)
                        }
                      ]
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "browseUrl",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "categoryCode",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "viewInRoomPhotos",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "viewInRoomPhotos",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "src",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "contemporaryTrackingString",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchPdp",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "isPdpUrlTranslationEnabled",
          "name": "isEnabled",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "translatedPdpUrls"
            }
          ],
          "storageKey": "isEnabled(key:\"translatedPdpUrls\")"
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isClient",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "transactions",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userIds"
            },
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemIds"
            }
          ],
          "concreteType": "TransactionConnection",
          "plural": false,
          "selections": [
            {
              "kind": "Condition",
              "passingValue": true,
              "condition": "isMultiSku",
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TransactionEdge",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Transaction",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "isPrivateOffer",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "isCanceled",
                          "args": null,
                          "storageKey": null
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'cbfe8461e44b491a323dc0d4c299728d';
export default node;
